import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ADecisionWasMade } from 'Modules/Status/Sections/ADecisionWasMade';
import { Determination } from 'Modules/Status/Sections/Determination';
import { ExpertReview } from 'Modules/Status/Sections/ExpretReview';
import { MedicalCommittee } from 'Modules/Status/Sections/MedicalCommittee';
import { Pause } from 'Modules/Status/Sections/Pause';
import { Recognition } from 'Modules/Status/Sections/Recognition';
import { Rejection } from 'Modules/Status/Sections/Rejection';
import { SubmissionReview } from 'Modules/Status/Sections/SubmissionReview';
import { useEffect, useState } from 'react';

interface ITextInformation {
  currentStepIcon: string;
  informationLabel: string;
}

export const TextInformation = ({
  currentStepIcon,
  informationLabel,
}: ITextInformation) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  const [textBlockComponent, setTextBlockComponent] = useState<React.ReactNode>(
    <></>
  );

  useEffect(() => {
    switch (informationLabel) {
      case dictionary.steps.step1.name:
        setTextBlockComponent(<SubmissionReview />);
        break;
      case dictionary.steps.step2.name:
        setTextBlockComponent(<MedicalCommittee />);
        break;
      case dictionary.steps.step3.name:
        setTextBlockComponent(<ADecisionWasMade />);
        break;
      case dictionary.steps.step3.nameIfCurrent:
        setTextBlockComponent(<ADecisionWasMade />);
        break;
      case dictionary.steps.step4.name:
        setTextBlockComponent(<ExpertReview />);
        break;
      case dictionary.steps.step5.name:
        setTextBlockComponent(<Determination />);
        break;
      case dictionary.steps.recognition.name:
        setTextBlockComponent(<Recognition />);
        break;
      case dictionary.steps.rejection.name:
        setTextBlockComponent(<Rejection />);
        break;
      case dictionary.steps.pause.name:
        setTextBlockComponent(<Pause />);
        break;
      default:
        setTextBlockComponent(<></>);
    }
  }, [dictionary.steps, informationLabel]);

  return (
    <Stack
      sx={{
        p: '24px',
        maxWidth: '610px',
        bgcolor: '#F6F8FE',
        border: '1px solid #B7CCFF',
        borderRadius: '16px',
        textAlign: 'left',
      }}
    >
      <Avatar
        alt=''
        src={currentStepIcon}
        sx={{ margin: '0 auto 16px auto', width: '73px', height: '70px' }}
      />
      <Typography variant='body1' component='h6' sx={{ mb: '12px' }}>
        {dictionary.importantToKnow}
      </Typography>
      {textBlockComponent}
    </Stack>
  );
};
